import React from 'react';
import styled, { css } from 'styled-components/macro';
import { useTranslate } from '../contexts/languageContext';
import constantes from '../resources/constantes.json';
import { isIE } from '../utils/index';

/**
 * Pestañas que permiten navegar entre elecciones en la pantalla de estadísticas
 */

const selected = css`
  border-bottom: 4px solid #f26722;
  border-top: 4px solid transparent;
  font-weight: bold;
`;

const TabsEleccion = ({ elec, setElec, ordEleccion }) => {
  const t = useTranslate();
  const IE = isIE();
  return (
    <STabsEleccion>
      {ordEleccion.map(x => {
        return (
          <button
            onClick={() => {
              setElec(Number(x));
            }}
          >
            <SH2 isselected={Number(x) === elec} isIE={IE}>
              {t(constantes.nombreEleccion[x])}
            </SH2>
          </button>
        );
      })}
    </STabsEleccion>
  );
};

export default TabsEleccion;

const STabsEleccion = styled.article`
  height: 7rem;
  background-color: rgba(225, 225, 221, 0.3);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding-left: 6rem;
  & button {
    background: none;
  }
`;
const SH2 = styled.h2`
  width: 8em;
  text-align: center;
  font-size: 1.4rem;
  height: ${({ isIE }) => (isIE ? '58px' : '62px')};
  line-height: ${({ isIE }) => (isIE ? '58px' : '62px')};
  cursor: pointer;
  ${({ isselected }) => (isselected ? selected : '')};
  :hover {
    ${selected};
  }
`;
